import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router";
import { resolveShortUrl } from "@/api/shortUrl";
import Loader from "./common/loader/Loader";

const ShortUrlRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!code) {
      navigate("/", { replace: true });
      return;
    }

    const resolve = async () => {
      try {
        const response = await resolveShortUrl(code);

        // API response: { status: "SUCCESS", data: "https://...hubzu.com/bank-owned-home/94520250620236" }
        if (response?.status === "SUCCESS" && response?.data) {
          const url = new URL(response.data);
          const redirectPath = url.pathname + url.search + url.hash;
          navigate(redirectPath, { replace: true });
        } else {
          setError(true);
        }
      } catch (err) {
        console.error("Failed to resolve short URL:", err);
        setError(true);
      }
    };

    resolve();
  }, [code, navigate]);

  if (error) {
    return (
      <div className="text-center mt-5">
        <h3>This link is invalid or has expired.</h3>
        <a href="/" className="btn btn-primary mt-3">Go to Home</a>
      </div>
    );
  }

  return <Loader />;
};

export default ShortUrlRedirect;
